import React from 'react';
import { motion, useAnimation } from 'framer-motion';

export default function QuizQuestionTimer({
  questionTime,
  questionDuration,
  onQuestionEnd,
  onQuestionAlreadyEnded,
  endedEarly,
}) {
  const now = moment().unix();
  const qTime = parseInt(questionTime.substring(0, 10));
  let timeDiff = now - qTime;
  if (timeDiff < 0) {
    timeDiff = 0;
  }
  let timeLeft;

  const timerAnimation = useAnimation();

  // ended
  if (timeDiff > questionDuration || endedEarly) {
    timeLeft = 0;
  }

  // poll is going
  else {
    timeLeft = questionDuration - timeDiff;
  }

  const [timer, setTimer] = React.useState(timeLeft);

  React.useEffect(() => {
    if (timer > 0) {
      timerAnimation.start({
        width: `${((timer - 1) / questionDuration) * 100}%`,
        transition: { duration: 1, ease: 'linear' },
      });
      let aInterval = setInterval(() => {
        if (timer === 1) {
          onQuestionEnd();
        }
        setTimer(old => old - 1);
      }, 1000);

      return () => {
        clearInterval(aInterval);
      };
    }
  }, [timer]);

  React.useEffect(() => {
    if (timer === 0) {
      onQuestionAlreadyEnded();
    }
  }, []);

  React.useEffect(() => {
    if (endedEarly) {
      setTimer(0);
      onQuestionEnd();
    }
  }, [endedEarly]);

  return (
    <div className={`question_timer`}>
      <div className={`question_timer__text`}>{timer > 0 ? `${timer}s` : 'Finished'}</div>
      <motion.div
        className={`question_timer__indicator`}
        initial={{ width: `${(timeLeft / questionDuration) * 100}%` }}
        animate={timerAnimation}
        style={endedEarly ? { display: 'none' } : {}}
      />
    </div>
  );
}
